import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppToolkitModule } from './app-toolkit.module';
import { AppMaterialModule } from './app-material.module';
import {
  BatchColumnDialogComponent,
  BatchComponent,
} from './pages/batch/batch.component';
import { ComponentCanDeactivateGuard } from './guards/component-can-deactivate.guard';
import { SearchDataService } from './services/searchData/search-data.service';
import { HeaderComponent } from './pages/page-components/header/header.component';
import { FooterComponent } from './pages/page-components/footer/footer.component';
import { TruncateLinesPipe } from './pages/page-components/truncate-lines.pipe';
import { ReplaceTextPipe } from './pipes/replace-text.pipe';
import { TruncateTextPipe } from './pipes/truncate-text.pipe';
import { CallbackComponent } from './pages/callback/callback.component';
import { HomeComponent } from './pages/home/home.component';
import { FilesComponent } from './pages/files/files.component';
import { DashboardComponent } from './pages/page-components/dashboard/dashboard.component';
import { DashboardItemComponent } from './pages/page-components/dashboard/dashboard-item/dashboard-item.component';
import { FileDownloadComponent } from './pages/file-download/file-download.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { LineItemListComponent } from './pages/line-item-list/line-item-list.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { ExportFileDialogComponent } from './pages/dialogs/export-file-dialog/export-file-dialog.component';
import { ValidationNoteDialogComponent } from './pages/dialogs/validation-note-dialog/validation-note-dialog.component';
import { ResultsColumnDialogComponent } from './pages/dialogs/results-column-dialog/results-column-dialog.component';
import { UpdateValidationDialogComponent } from './pages/dialogs/update-validation-dialog/update-validation-dialog.component';
import { ReportsComponent } from './pages/reports/reports.component';
import { SearchXrefComponent } from './pages/search-xref/search-xref.component';
import { SearchParametersComponent } from './pages/page-components/Parameters/search-parameters/search-parameters.component';
import { UnspscSearchParametersComponent } from './pages/page-components/Parameters/unspsc-search-parameters/unspsc-search-parameters.component';
import { NavMenuComponent } from './pages/page-components/nav-menu/nav-menu.component';
import { XrefDisplayComponent } from './Xrefs/xref-display/xref-display.component';
import { XrefListComponent } from './pages/requests/xref-list/xref-list.component';
import { CccReportComponent } from './pages/reports/ccc-report/ccc-report.component';
import { CccReportParametersComponent } from './pages/page-components/Parameters/ccc-report-parameters/ccc-report-parameters.component';
import { InfoDialogComponent } from './pages/dialogs/info-dialog/info-dialog.component';
import { UploadFileDialogComponent } from './pages/dialogs/upload-file-dialog/upload-file-dialog.component';
import { SafePipePipe } from './pipes/safe-pipe.pipe';
import { MyRequestsComponent } from './pages/requests/my-requests/my-requests.component';
import { HighlightPipe } from './pipes/highlight.pipe';
import { NewRequestDialogComponent } from './pages/dialogs/new-request-dialog/new-request-dialog.component';
import { ConversionSelectionDialogComponent } from './pages/dialogs/conversion-selection-dialog/conversion-selection-dialog.component';
import { MdmInputComponent } from './pages/page-components/mdm-input/mdm-input.component';
import { TruncatePipe } from './pages/page-components/truncate.pipe';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    SearchXrefComponent,
    FilesComponent,
    ReportsComponent,
    NavMenuComponent,
    BatchComponent,
    PageNotFoundComponent,
    HighlightPipe,
    BatchColumnDialogComponent,
    UnauthorizedComponent,
    LineItemListComponent,
    DashboardComponent,
    CallbackComponent,
    SearchParametersComponent,
    FileDownloadComponent,
    TruncateLinesPipe,
    UnspscSearchParametersComponent,
    ExportFileDialogComponent,
    UpdateValidationDialogComponent,
    ResultsColumnDialogComponent,
    ValidationNoteDialogComponent,
    ReplaceTextPipe,
    TruncateTextPipe,
    DashboardItemComponent,
    XrefDisplayComponent,
    CccReportComponent,
    CccReportParametersComponent,
    InfoDialogComponent,
    UploadFileDialogComponent,
    SafePipePipe,
    MyRequestsComponent,
    XrefListComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AppToolkitModule,
    AppMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NewRequestDialogComponent,
    ConversionSelectionDialogComponent,
    MdmInputComponent,
    TruncatePipe,
  ],
  providers: [ComponentCanDeactivateGuard, SearchDataService],
  bootstrap: [AppComponent],
})
export class AppModule {}
